var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewdoc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1289 2H8.12891C4.12891 2 2.12891 4 2.12891 8V21C2.12891 21.55 2.57891 22 3.12891 22H16.1289C20.1289 22 22.1289 20 22.1289 16V8C22.1289 4 20.1289 2 16.1289 2Z",
    stroke: "#5C6E7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0377 7.84015L7.84772 13.0302C7.64772 13.2302 7.45773 13.6202 7.41773 13.9002L7.13773 15.8802C7.03773 16.6002 7.53772 17.1002 8.25772 17.0002L10.2377 16.7202C10.5177 16.6802 10.9077 16.4902 11.1077 16.2902L16.2977 11.1002C17.1877 10.2102 17.6177 9.17015 16.2977 7.85015C14.9777 6.52015 13.9377 6.94015 13.0377 7.84015Z",
    stroke: "#5C6E7D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2969 8.58008C12.7369 10.1501 13.9669 11.3901 15.5469 11.8301",
    stroke: "#5C6E7D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewdoc);
export default __webpack_public_path__ + "static/media/newdoc.1d990f38c22500ba9a70813b4ba4b4f2.svg";
export { ForwardRef as ReactComponent };